import { RestApiRequest } from "../Models/RestApiRequest";
import { fetchData } from "./BaseService";

export const getProjectJobsStatusApi = async (projectId?: number) => {
  var request: RestApiRequest = {
    url: "/api/projects/project/jobsstatus?projectid=" + projectId,
    method: "GET",
    headers: { "Content-type": "application/json; charset=UTF-8" },
  };
  const response = await fetchData(request);
  return response;
};

export const importDailyData = async (projectId: number | undefined, jobId: number | undefined, jobHistoryId: number | undefined, startDate: string, endDate: string) => {
  var request: RestApiRequest = {
    url: "/api/projects/project/jobimportdailydata",
    body: { projectid: projectId, jobid: jobId, jobhistoryid: jobHistoryId, startdate: startDate, enddate: endDate },
    method: "POST",
  };
  const response = await fetchData(request);
  return response;
};

export const importDailyTrackingData = async (projectId: number | undefined, jobId: number | undefined, jobHistoryId: number | undefined, startDate: string, endDate: string) => {
  var request: RestApiRequest = {
    url: "/api/projects/project/jobimportdailytrackingdata",
    body: { projectid: projectId, jobid: jobId, jobhistoryid: jobHistoryId, startdate: startDate, enddate: endDate },
    method: "POST",
  };
  const response = await fetchData(request);
  return response;
};